import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack } from '@mui/material';
import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';
import MemberSearch from '../../Shared/MemberSearch';
import { useAppDispatch } from '../../../store/store';

const TeamOptimizerSelectMember = (props) => {
    const dispatch = useAppDispatch();

    const getIdsArray = (arr) => {
        if (!arr) return [];
        if (arr.ids) {
            return arr.ids instanceof Set ? Array.from(arr.ids) : arr.ids;
        }
        return Array.isArray(arr) ? arr : [];
    };

    const hasValidSelection = (selectionModel) => {
        const idsArray = getIdsArray(selectionModel);
        return Array.isArray(idsArray) && idsArray.length > 0;
    };

    const listOfSelectedMembers = (arr) => {
        const idsArray = getIdsArray(arr);

        if (idsArray.length === 0) {
            return;
        }

        const listOfSelectedMembers = idsArray.map((el) => props.allMembers.find((member) => member.Id === el));
        const selected = listOfSelectedMembers.filter((el) => el !== undefined).map((el) => ({ ...el }));
        dispatch(props.setSelectedMembers(selected));
        props.onClose();
    };

    const columns: GridColDef[] = [
        {
            field: 'LastName',
            headerName: 'Last Name',
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'HealthPlan',
            headerName: 'Health Plan',
            minWidth: 200,
        },
        {
            field: 'RiskLevel',
            headerName: 'RiskLevel',
            minWidth: 100,
        },
        {
            field: 'RiskScore',
            headerName: 'RiskScore',
            minWidth: 100,
        },
        {
            field: 'TeamName',
            headerName: 'Team',
            minWidth: 200,
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        <Stack>
                            {params.row.TeamName?.split(',').map((item, key) => {
                                return <label key={key}>{item}</label>;
                            })}
                        </Stack>
                    </>
                );
            },
        },
        {
            field: 'Status',
            headerName: 'Status',
            minWidth: 200,
            flex: 1,
        },
    ];

    return (
        <>
            <Dialog open={props.open} onClose={props.onClose} fullWidth disableEnforceFocus maxWidth="xl">
                <DialogTitle>Add Members</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} paddingTop={2}>
                        <Grid size={4}>
                            <MemberSearch
                                rowData={props.memberSearch.rowData}
                                allMembers={props.memberSearch.allMembers}
                                setRowData={props.memberSearch.setRowData}
                                memberSearchValue={props.memberSearch.memberSearchValue}
                                setMemberSearchValue={props.memberSearch.setMemberSearchValue}
                            />
                        </Grid>
                        <Grid size={12}>
                            <div style={{ height: '64vh', width: '100%' }}>
                                <DataGrid
                                    rows={props.rowData}
                                    columns={columns}
                                    paginationModel={{ pageSize: props.pageSize, page: props.page || 0 }}
                                    checkboxSelection
                                    rowSelectionModel={props.selectionModel}
                                    onRowSelectionModelChange={props.onSelectionModelChange}
                                    pageSizeOptions={[5]}
                                    onPaginationModelChange={(model) => props.pageSizeHandler(model.pageSize, model.page)}
                                    getRowId={(row) => row.Id}
                                    getRowHeight={() => 'auto'}
                                    sx={{
                                        [`& .${gridClasses.cell}`]: {
                                            py: 1,
                                        },
                                        [`& .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root`]: {
                                            display: 'none',
                                        },
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        className="button-120"
                        style={{ whiteSpace: 'nowrap' }}
                        disabled={!hasValidSelection(props.selectionModel)}
                        onClick={() => listOfSelectedMembers(props.selectionModel)}
                    >
                        Select Members
                    </Button>
                    <Button className="button-120" variant="outlined" onClick={props.onClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TeamOptimizerSelectMember;
